import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app relative z-[2147483647]" }

import {
  ref,
} from 'vue';
import {
  useStore,
} from '@/store';
import ChatApp from '@/views/ChatApp.vue';
import ChatIcon from '@/views/ChatIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const utilStore = useStore.util;

const isChatInterfaceLoaded = ref(false);

function openInterface(): void {
  isChatInterfaceLoaded.value = true;
  utilStore.isChatOpen = true;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(ChatIcon, { "onInterface:open": openInterface }, null, 512), [
      [_vShow, !_unref(utilStore).isChatOpen]
    ]),
    (isChatInterfaceLoaded.value)
      ? _withDirectives((_openBlock(), _createBlock(ChatApp, {
          key: 0,
          "onInterface:close": _cache[0] || (_cache[0] = ($event: any) => (_unref(utilStore).isChatOpen = false))
        }, null, 512)), [
          [_vShow, _unref(utilStore).isChatOpen]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})